module.exports = __webpack_public_path__ + "static/media/img12.173c5f71.jpg";